import axios from "axios";
import Loading from "vue-loading-overlay";
import AddUpcomingBookModal from "../template/AddUpcomingBookModal";
export default {
    name: "UpcomingBookList",
    components:{Loading,AddUpcomingBookModal},
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
           upcomingList:[]
        }
    },
    async created() {
        await this.getList();
    },
    methods: {
        async getList() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version4 +
                    "/upcoming",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                //console.log(res)
                if (res.status === 201) {
                    // console.log(res.data.data)
                    this.upcomingList = res.data.data
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        removeBook: async function (id) {
            this.$swal.fire({
                title: 'Are you sure?',
                text: "Are you sure to remove this data?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const token = localStorage.getItem(this.$tokenKey);
                        const res = await axios.delete(
                            this.$baseUrl + this.$api + this.$version4 + "/upcoming/?id=" +id,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        this.isLoading = false;
                        if (res.status === 200 || res.status === 201 ) {
                            this.$vToastify.success("deleted successfully!");
                            await this.getList();
                        }
                    } catch (error) {
                        console.log(error);
                        await this.getList();
                        this.$swal.fire({
                            icon: "error",
                            text: "An error occurred!"
                        });
                    }
                }
            })
        },
    }
}
